module.exports = __webpack_public_path__ + "static/img/kf_cloud_00007.739e988.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kf_cloud_00007.jpg
// module id = 178
// module chunks = 1